<template>
  <div :menu-fix="false">
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[$t('menu.carrySettlements'), $t('text.create')]"
      ></breadcrumb>
      <div class="container">
        <el-form
          ref="settleObjForm"
          :model="settleObj"
          label-width="100px"
          size="small"
        >
          <div class="pd20">
            <fieldset>
              <legend>
                {{ $t("text.baseInfo") }}
              </legend>
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="$t('settlement.title')">{{
                    settleObj.title
                  }}</el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item :label="$t('settlement.amount')">
                    {{ settleObj.amount | currency }}
                  </el-form-item>
                </el-col>
                <el-form-item :label="$t('settlement.totalQuantity')">{{
                  settleObj.deliveryQuantity
                }}</el-form-item>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item :label="$t('delivery.sender')">{{
                    settleObj.clientName
                  }}</el-form-item>
                </el-col>
              </el-row>
            </fieldset>
          </div>
          <div class="form-footer">
            <el-button
              type="primary"
              size="medium"
              plain
              :loading="saveDoing"
              @click="saveSubmit"
              >{{ $t("text.submit") }}</el-button
            >
            <back-button />
          </div>
          <div class="pd20">
            <fieldset>
              <legend>
                {{ $t("text.detail") }}
              </legend>
              <vxe-table
                :data="items"
                ref="itemsTable"
                class="recordsTable"
                size="mini"
                highlight-hover-row
                :scroll-y="{ enabled: false }"
              >
                <vxe-table-column
                  field="serialNo"
                  :title="$t('text.serialNo')"
                  min-width="100"
                >
                  <template v-slot="{ row }">
                    {{ row.serialNo }}
                    <div v-if="row.settle == true" class="green font10">
                      {{ $t("delivery.settle") }}
                    </div>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="customerName"
                  :title="$t('menu.customers')"
                  min-width="100"
                >
                  <template v-slot="{ row }">
                    <el-popover placement="right" width="260" trigger="click">
                      <div>
                        <div class="lineH24">
                          {{ $t("menu.customers") }}：{{ row.customerName }}
                        </div>
                        <div class="lineH24">
                          {{ $t("courier.phone") }}：{{ row.customerPhone }}
                        </div>
                        <div class="lineH24">
                          {{ $t("tenant.country") }}：
                          <span v-if="row.customerCountry != null">{{
                            $t("countries." + row.customerCountry)
                          }}</span>
                        </div>
                        <div class="lineH24">
                          {{ $t("tenant.province") }}：{{
                            row.customerProvince
                          }}
                        </div>
                        <div class="lineH24">
                          {{ $t("tenant.city") }}：{{ row.customerCity }}
                        </div>
                        <div class="lineH24">
                          {{ $t("tenant.address") }}：{{ row.customerAddress }}
                        </div>
                        <div class="lineH24">
                          {{ $t("customer.zipcode") }}：{{
                            row.customerZipcode
                          }}
                        </div>
                      </div>
                      <div slot="reference" class="popover-reference">
                        {{ row.customerName }}
                      </div>
                    </el-popover>
                  </template>
                </vxe-table-column>

                <vxe-table-column
                  :title="$t('delivery.deliverCost')"
                  min-width="100"
                >
                  <template v-slot="{ row }">
                    <el-input
                      v-model="row.courierCost"
                      size="small"
                      @blur="computeAmount"
                    />
                    <el-input
                      v-model="row.extraCharge"
                      size="small"
                      :placeholder="$t('order.extraCharge')"
                      @blur="computeAmount"
                    />
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  :title="$t('settlement.explain')"
                  min-width="120"
                >
                  <template v-slot="{ row }">
                    <el-input
                      v-model="row.explain"
                      size="small"
                      width="100"
                      :placeholder="$t('settlement.explain')"
                    />
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="action"
                  :title="$t('text.action')"
                  width="50"
                >
                  <template v-slot="{ row, rowIndex }">
                    <el-button
                      type="text"
                      size="mini"
                      @click="remove(row, rowIndex)"
                    >
                      {{ $t("text.remove") }}
                    </el-button>
                  </template>
                </vxe-table-column>
              </vxe-table>
            </fieldset>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import ls from "store2";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import BackButton from "@/components/BackButton";
import Currency from "@/components/Currency";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";

//
import Delivery from "@/api/delivery.js";
import Courier from "@/api/courier.js";
import DeliverySettlement from "@/api/deliverySettlement.js";

export default {
  mixins: [page],
  components: {
    BackButton,
    Currency,
    RawHtmlLimitNumber,
  },
  data() {
    return {
      items: [],
      Util: Util,
      settleObj: {
        title: null,
        amount: null,
        deliveryQuantity: null,
        settleType: "carry",
        deliveries: [],
        clientId: null,
        clientName: null,
      },

      saveDoing: false,
    };
  },
  mounted() {},
  created() {
    const self = this;
    self.loadingStart();
    self.settleObj.title = self.$route.params.title;
    axios.all([Delivery.unSettle(self.$route.query)]).then(
      axios.spread(function (items) {
        self.loadingEnd();
        if (items.status === 200) {
          self.items = items.data;
          for (const item of self.items) {
            Vue.set(item, "courierCost", Number(item.deliverCost || 0));
          }
          self.computeAmount();
        } else {
          self.sysError();
        }
      })
    );
  },

  methods: {
    remove(row, rowIndex) {
      this.items.splice(rowIndex, 1);
      this.computeAmount();
    },
    computeAmount() {
      const self = this;
      self.settleObj.amount = 0;
      self.settleObj.deliveryQuantity = self.items.length;
      for (const item of self.items) {
        self.settleObj.amount =
          Number(self.settleObj.amount) +
          Number(item.courierCost || 0) +
          Number(item.extraCharge || 0);
      }
    },
    //
    saveSubmit() {
      let self = this;
      if (self.items.length === 0) {
        this.$message({
          message: self.$t("prompt.atLeastOneData"),
          type: "warning",
        });
        return;
      }
      for (const o of self.items) {
        if (!Util.regexPrice(o.courierCost)) {
          self.$message({
            message: self.$t("rules.regex", [
              self.$t("settlement.settleTotal"),
            ]),
            type: "warning",
          });
          return;
        }
      }
      self.settleObj.deliveries = self.items.map((item) => {
        return {
          id: item.id,
          courierCost: item.courierCost,
          extraCharge: item.extraCharge,
          explain: item.explain,
        };
      });

      self.saveDoing = true;
      DeliverySettlement.create(self.settleObj).then(function (res) {
        self.saveDoing = false;
        if (res.status == 200) {
          self.$message({
            message: self.$t("prompt.addSuccess"),
            type: "success",
          });
          self.$router.push({ name: "fnReportsDeliverSettlementsCarry" });
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.name {
  text-overflow: ellipsis;
  overflow: hidden;
}
.addr {
  font-size: 12px;
  color: #b4b4b4;
}
</style>